<template>
    <div class="page-padding">
        <BenchmarkHeader title="Benchmark" @toogle-edit-on-table="editingOnTable = !editingOnTable" />
        <BenchmarkTable :editOn="editingOnTable"/>
    </div>
</template>
<script setup lang="ts">
import BenchmarkHeader from '@/components/BenchmarkHeader.vue';
import BenchmarkTable from '@/components/BenchmarkTable.vue';
import {ref} from 'vue';

const editingOnTable = ref(false);

</script>